import { render, staticRenderFns } from "./LettersList.vue?vue&type=template&id=18b8c8b4&scoped=true&"
import script from "./LettersList.vue?vue&type=script&lang=js&"
export * from "./LettersList.vue?vue&type=script&lang=js&"
import style0 from "./LettersList.vue?vue&type=style&index=0&id=18b8c8b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b8c8b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/dev/www/word-trainer-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VContainer,VFlex,VLayout})
